import { render, staticRenderFns } from "./ListHistory.vue?vue&type=template&id=7a404d22&scoped=true&"
import script from "./ListHistory.vue?vue&type=script&lang=js&"
export * from "./ListHistory.vue?vue&type=script&lang=js&"
import style0 from "./ListHistory.vue?vue&type=style&index=0&id=7a404d22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a404d22",
  null
  
)

export default component.exports